import React from 'react';
import { connect } from 'react-redux'
import { _success, _validationFormMsg, _setAxios, _logout } from '../../lib/Helper';
import validate from 'validate.js';

import { Layout, Modal, Button, Menu, Row, Col, List, Avatar, Dropdown, Drawer, Divider } from 'antd';
import { MenuUnfoldOutlined, DownCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { noImage } from '../../data/image';
import { BrowserView, MobileView } from 'react-device-detect';
import logoMan from '../../assets/images/logo-man.png';
import "./style.css"

const { Header } = Layout;

const schema = {
  password_old: {
    presence: { allowEmpty: false, message: 'wajib diisi' },
    length: {
      maximum: 100
    }
  },
  password_new: {
    presence: { allowEmpty: false, message: 'wajib diisi' },
    length: {
      maximum: 100
    }
  },
  password_new_confirm: {
    presence: { allowEmpty: false, message: 'wajib diisi' },
    length: {
      maximum: 100
    },
    equality: {
      attribute: "password_new",
      message: "wajib sama dengan password baru",
      comparator: function (v1, v2) {
        return JSON.stringify(v1) === JSON.stringify(v2);
      }
    },
  }
};

// const messageContent = (
//   <List
//     className='message-content'
//     itemLayout="horizontal"
//     dataSource={dataMessage}
//     renderItem={item => (
//       <List.Item>
//         <List.Item.Meta
//           avatar={<Avatar src={noImage} />}
//           title={<a href="https://ant.design">{item.title}</a>}
//           description="Man Digital, a design language for background applications"
//         />
//       </List.Item>
//     )}
//   />
// );

class HeaderLayout extends React.Component {
  state = {
    collapsed: false,
    openKey: 0,
    selectedKey: 0,
    updatePassword: {
      visible: false,
      loading: false
    },
    values: {},
    errors: {},
    drawer: {
      visible: false
    }
  };

  handleLogOut() {
    Modal.confirm({
      title: 'Keluar',
      width: 270,
      icon: <ExclamationCircleOutlined />,
      content: <>Apakah Anda Yakin ?</>,
      cancelText: 'Batal',
      okText: 'Keluar',
      onOk: () => {
        _logout()
      },
      onCancel: () => {
        console.log("No action to process")
      },
    });
  }

  // UPDATE PASSWORD START ------------------------------------------

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setForm(name, value)
  };

  setForm = (name, value, row = {}) => {
    const { values } = this.state;
    values[name] = value;
    const errors = validate(values, schema);
    this.setState({
      values: values,
      errors: errors || {},
    });
  }

  hasError = field => {
    return this.state.errors[field] ? true : false;
  }
  showModalUpdatePassword = (row) => {
    this.setState({
      updatePassword: {
        visible: true,
        loading: false
      },
    });
  };

  hideModalUpdatePassword = () => {
    this.setState({
      updatePassword: {
        visible: false,
        loading: false
      }
    });
  };

  updatePasswordSubmit = (e) => {
    e.preventDefault();
    const { values } = this.state;
    const errors = validate(values, schema);
    if (errors) {
      return _validationFormMsg(errors)
    }

    this.setState({
      updatePassword: {
        ...this.state.updatePassword,
        loading: true
      }
    });
    _setAxios("user/ubah-password/" + this.props.privilege.profile.id, "PUT", {
      password_old: values.password_old,
      password_new: values.password_new,
      password_confirm: values.password_new_confirm,
    }).then(resp => {
      if (resp.status === true) {
        this.hideModalUpdatePassword()
        _success('topRight', 'Success', resp.data.message)
      } else {
        this.setState({
          updatePassword: {
            ...this.state.updatePassword,
            loading: false
          }
        });
      }
    })

  };
  // UPDATE PASSWORD END ------------------------------------------


  onMenuCollapse = () => {
    this.props.setMenuCollapse(!this.props.menuCollapse)
  }

  showDrawer = () => {
    this.setState({
      drawer: {
        visible: true,
      },
    });
  };

  closeDrawer = () => {
    this.setState({
      drawer: {
        visible: false,
      },
    });
  };

  closeDrawerParent = (path) => {
    if (path === "" || path === "/" || path === "#") {
      this.closeDrawer()
    }
  };

  getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  render() {
    const { values, errors } = this.state
    const privilege = this.props.privilege

    const profileContent = (
      <List
        className='message-content'
        itemLayout="horizontal"
        dataSource={[""]}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              // avatar={<Avatar src={noImage} />}
              // title={privilege.profile.name}
              description={<>
                <Menu>
                  {/* <Menu.Item>
                    <Link to={"/profile"}>
                      Profil
                    </Link>
                  </Menu.Item> */}
                  <Menu.Item onClick={this.showModalUpdatePassword}>
                    Ganti Password
                  </Menu.Item>
                  <Menu.Item onClick={this.handleLogOut}>
                    Logout
                  </Menu.Item>
                </Menu>
              </>}
            />
          </List.Item>
        )}
      />
    );

    const modalUpdatePassword = <Modal
      title={`Ganti Password Akun - ` + privilege.profile.name}
      onCancel={this.hideModalUpdatePassword}
      visible={this.state.updatePassword.visible}
      footer={<>
        <Button onClick={this.hideModalUpdatePassword}>Batal</Button>
        <Button type="primary" htmlType="submit" onClick={this.updatePasswordSubmit} loading={this.state.updatePassword.loading}>Simpan</Button>
      </>}

    >
      <form autoComplete="off" onSubmit={this.updatePasswordSubmit}>
        <Row gutter={[24, 24]}>
          <Col xs={24}>
            <TextField
              fullWidth
              label="Password Lama"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              name="password_old"
              type="password"
              onChange={this.handleChange}
              value={values.password_old || ''}
              error={this.hasError('password_old')}
              helperText={
                this.hasError('password_old') ? errors.password_old[0] : null
              }
            />
          </Col>
          <Col xs={24}>
            <TextField
              fullWidth
              label="Password"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              name="password_new"
              type="password"
              onChange={this.handleChange}
              value={values.password_new || ''}
              error={this.hasError('password_new')}
              helperText={
                this.hasError('password_new') ? errors.password_new[0] : null
              }
            />
          </Col>
          <Col xs={24}>
            <TextField
              fullWidth
              label="Konfirmasi Password"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              name="password_new_confirm"
              type="password"
              onChange={this.handleChange}
              value={values.password_new_confirm || ''}
              error={this.hasError('password_new_confirm')}
              helperText={
                this.hasError('password_new_confirm') ? errors.password_new_confirm[0] : null
              }
            />
          </Col>
        </Row>
      </form>
    </Modal>

    // const menu = this.props.menu
    // const items = []
    // for (let i = 0; i < menu.length; i++) {
    //   const subItems = []
    //   if (menu[i].children) {
    //     if (menu[i].children.length > 0) {
    //       for (let j = 0; j < menu[i].children.length; j++) {
    //         const subMenu = menu[i].children[j]
    //         subItems.push(
    //           <Col xs={8}>
    //             <div style={{
    //               textAlign: "center",
    //               padding: 16,
    //               borderRadius: 8,
    //               height: "100%",
    //               boxShadow: "0 3px 6px #0000001c"
    //             }}>
    //               <div><Link to={subMenu.path}><Button shape="circle" icon={<CodeSandboxOutlined />} onClick={this.closeDrawer} /></Link></div>
    //               <div style={{ fontSize: "60%", marginTop: 8 }}>{subMenu.name}</div>
    //             </div>
    //           </Col>)
    //       }
    //     }
    //   }

    //   if (items.length > 0) {
    //     items.push(<>
    //       <Col xs={24}>
    //         <div>{menu[i].name}</div>
    //       </Col>
    //       {subItems}
    //     </>)
    //   } else {
    //     items.push(<>
    //       <Col xs={8}></Col>
    //       <Col xs={8}>
    //         <div style={{
    //           textAlign: "center",
    //           padding: 16,
    //           borderRadius: 8,
    //           height: "100%",
    //           boxShadow: "0 3px 6px #0000001c"
    //         }}>
    //           <div><Link to={menu[i].path}><Button shape="circle" icon={<CodeSandboxOutlined />} onClick={this.closeDrawer} /></Link></div>
    //           <div style={{ fontSize: "60%", marginTop: 8 }}>{menu[i].name}</div>
    //         </div>
    //       </Col>
    //     </>
    //     )
    //   }
    // }

    const menu = this.props.menu
    const items = []
    for (let i = 0; i < menu.length; i++) {
      const subItems = []
      if (menu[i].children) {
        if (menu[i].children.length > 0) {
          for (let j = 0; j < menu[i].children.length; j++) {
            const subMenu = menu[i].children[j]
            subItems.push(this.getItem(<Link onClick={this.closeDrawer} to={subMenu.path}>{subMenu.name}</Link>, (subMenu.path ? subMenu.path : i), <span className="icon-sidebar icon-circle" style={{ fontSize: "60%" }}></span>))
          }
        }
      }
      items.push(this.getItem(<Link onClick={this.closeDrawerParent.bind(this, menu[i].path)} to={menu[i].path}>{menu[i].name}</Link>, menu[i].path ? menu[i].path : i, menu[i].icon ? <span className={`icon-sidebar ${menu[i].icon}`}></span> : <span className="icon-sidebar icon-dashboard"></span>, subItems.length > 0 ? subItems : null))
    }


    let styleProfile = {
      margin: "-54px auto 0px",
      width: "fit-content"
    }
    let styleProfileImage = {
      backgroundImage: `url("` + logoMan + `")`,
      backgroundColor: "rgb(255, 255, 255)",
      padding: "8px",
      borderRadius: "100%",
      width: "80px",
      overflow: "hidden",
      height: "80px",
      backgroundSize: "56px",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      border: "3px solid rgb(224 224 224 / 50%)"
    }

    return (
      <>
        <Header className="site-layout-background" style={{
          borderRadius: 0
        }}>
          <Row gutter={[16, 16]}>
            <Col xs={12}>
              <BrowserView>
                <Button type="primary" icon={<MenuUnfoldOutlined />}
                  onClick={this.onMenuCollapse}
                />
              </BrowserView>
              <MobileView>
                {/* <Button type="primary" icon={<MenuUnfoldOutlined />} onClick={this.showDrawer} /> */}
                <div style={{
                  backgroundImage: `url(${logoMan})`,
                  width: 40,
                  height: 60,
                  backgroundSize: 40,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                }}></div>
              </MobileView>
            </Col>
            <Col xs={12}>
              <div className='nav-profile'>
                <Dropdown overlay={profileContent} trigger={['click']} placement="bottomRight">
                  <div>
                    <div className="navbar-grid-container">
                      <div className="navbar-icon"><Avatar src={noImage} /></div>
                      <div className="navbar-title1">Masuk sebagai</div>
                      <div className="navbar-title2">{privilege.profile.roles}</div>
                      <div className="navbar-icon2"><DownCircleOutlined /></div>
                    </div>
                  </div>

                </Dropdown>
              </div>
            </Col>
          </Row>
        </Header>

        <Drawer title={false} placement="left" onClose={this.closeDrawer} visible={this.state.drawer.visible} width={320}>
          <Row gutter={[16, 16]}>
            {
              this.props.menuCollapse ? "" :
                <Col xs={24}>
                  <div className='sidebar-profile'>
                    <div className='sidebar-grid-container'>
                    </div>
                  </div>
                </Col>
            }
            <Col xs={24}>
              <div style={styleProfile}>
                <div style={styleProfileImage}>
                </div>
              </div>
            </Col>
            <Col xs={24} style={{
              textAlign: "center"
            }}>
              <div style={this.props.menuCollapse ? {
                fontSize: '50%'
              } : {
                fontWeight: "bold"
              }}>{this.props.privilege.profile.name}</div>
              <div style={this.props.menuCollapse ? {
                fontSize: '50%',
                color: "#8C8C8C"
              } : {
                color: "#8C8C8C"
              }}>{this.props.privilege.profile.roles}</div>
              <Divider />
            </Col>
          </Row>
          <Menu
            // defaultSelectedKeys={[pathname]}
            // defaultOpenKeys={[openKey]}
            mode="inline"
            items={items} />
        </Drawer>

        {modalUpdatePassword}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
    menu: state.menu,
    menuCollapse: state.menuCollapse
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setMenuCollapse: (flag) => {
      dispatch({ type: "MENU", menuCollapse: flag })
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(HeaderLayout);
